<template>
  <el-dialog :title="$t('buildingManage.edit.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.name')" prop="name">
            <el-input v-model="form.name" :placeholder="$t('buildingManage.edit.namePlaceholder')" />
          </el-form-item>
        </el-col>
        <!--<el-col :span="12">-->
        <!--  <el-form-item :label="$t('buildingManage.edit.intro')" prop="intro">-->
        <!--    <el-input v-model="form.intro" :placeholder="$t('buildingManage.edit.introPlaceholder')" />-->
        <!--  </el-form-item>-->
        <!--</el-col>-->
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.telephone')" prop="telephone">
            <el-input v-model="form.telephone" :placeholder="$t('buildingManage.edit.telephonePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('buildingManage.edit.intro')" prop="intro">
        <el-input v-model="form.intro" :placeholder="$t('buildingManage.edit.introPlaceholder')" />
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.tags')" prop="tags">
            <el-input v-model="form.tags" :placeholder="$t('buildingManage.edit.tagsPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.discountInfo')" prop="discountInfo">
            <el-input v-model="form.discountInfo" :placeholder="$t('buildingManage.edit.discountInfoPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.coverImg')" prop="coverImg">
            <upload-image-url ref="coverImage" :limit="1" @notifyUploadCoverImage="handleCoverImageChange" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.headerImg')" prop="headerImg">
            <upload-image-url ref="headerImage" :limit="1" @notifyUploadCoverImage="handleHeaderImageChange" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.unitPrice')" prop="unitPrice">
            <el-input v-model="form.unitPrice" :placeholder="$t('buildingManage.edit.unitPricePlaceholder')">
              <template slot="append">元/平</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.totalPrice')" prop="totalPrice">
            <el-input v-model="form.totalPrice" :placeholder="$t('buildingManage.edit.totalPricePlaceholder')">
              <template slot="append">万元/套</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.showPrice')" prop="showPrice">
            <el-select v-model="form.showPrice" :placeholder="$t('buildingManage.edit.showPricePlaceholder')" style="width:100%">
              <el-option :label="$t('common.yes')" :value="'1'" />
              <el-option :label="$t('common.no')" :value="'0'" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.salesStatus')" prop="salesStatus">
            <el-select v-model="form.salesStatus" :placeholder="$t('buildingManage.edit.salesStatusPlaceholder')"
              style="width:100%">
              <el-option :label="$t('buildingManage.salesStatusOptions.toBeSold')" value="待售" />
              <el-option :label="$t('buildingManage.salesStatusOptions.onSale')" value="在售" />
              <el-option :label="$t('buildingManage.salesStatusOptions.soldOut')" value="售罄" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.houseType')" prop="houseType">
            <el-input v-model="form.houseType" :placeholder="$t('buildingManage.edit.houseTypePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.buildingType')" prop="buildingType">
            <el-input v-model="form.buildingType" :placeholder="$t('buildingManage.edit.buildingTypePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.propertyRight')" prop="propertyRight">
            <el-input v-model="form.propertyRight" :placeholder="$t('buildingManage.edit.propertyRightPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('buildingManage.edit.address')" prop="address">
        <el-input v-model="form.address" :placeholder="$t('buildingManage.edit.addressPlaceholder')" />
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.lat')" prop="lat">
            <el-input v-model="form.lat" :placeholder="$t('buildingManage.edit.latPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.edit.lng')" prop="lng">
            <el-input v-model="form.lng" :placeholder="$t('buildingManage.edit.lngPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('buildingManage.edit.position')" _label="定位">
        <select-tianditu-pos ref="selectMapPos" @position-change="handlePositionChange"></select-tianditu-pos>
      </el-form-item>

      <el-form-item :label="$t('buildingManage.edit.buildingDesc')" prop="buildingDesc">
        <rich-text-editor ref="buildingDescEditor" v-model="form.buildingDesc" />
      </el-form-item>
      <el-form-item :label="$t('buildingManage.edit.features')" prop="features">
        <rich-text-editor ref="featuresEditor" v-model="form.features" />
      </el-form-item>

      <el-form-item :label="$t('buildingManage.edit.houseInfo')" prop="houseInfo">
        <div class="house-info-container">
          <el-row :gutter="20">
            <el-col :span="4">分类</el-col>
            <el-col :span="4">照片</el-col>
            <el-col :span="4">名称</el-col>
            <el-col :span="3">面积</el-col>
            <el-col :span="3">状态</el-col>
            <el-col :span="3">价格</el-col>
            <el-col :span="3"></el-col>
          </el-row>
          <div 
            v-for="(house, index) in form.houseInfo" 
            :key="index" 
            class="house-item"
          >
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.category'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseCategoryRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="house.category" 
                    :placeholder="$t('buildingManage.edit.houseCategoryPlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.img'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseImgRequired'), trigger: 'blur' }"
                >
                  <upload-image-url 
                    :ref="'houseImage_' + index"
                    :limit="1"
                    @notifyUploadCoverImage="(images) => handleHouseImageChange(index, images)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.name'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseNameRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="house.name" 
                    :placeholder="$t('buildingManage.edit.houseNamePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.size'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseSizeRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="house.size" 
                    :placeholder="$t('buildingManage.edit.houseSizePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.state'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseStateRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="house.state" 
                    :placeholder="$t('buildingManage.edit.houseStatePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.price'"
                >
                  <el-input 
                    v-model="house.price" 
                    :placeholder="$t('buildingManage.edit.housePricePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-button 
                    type="danger" 
                    icon="el-icon-delete" 
                    circle 
                    @click="removeHouse(index)"
                  ></el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          
          <el-button 
            type="primary" 
            icon="el-icon-plus" 
            @click="addHouse"
          >
            {{ $t('buildingManage.edit.addHouse') }}
          </el-button>
        </div>
      </el-form-item>

      <el-form-item :label="$t('buildingManage.edit.salesInfo')" prop="salesInfo">
        <div class="sales-info-container">
          <el-row :gutter="20">
            <el-col :span="4">姓名</el-col>
            <el-col :span="4">头像</el-col>
            <el-col :span="4">职位</el-col>
            <el-col :span="4">电话</el-col>
            <el-col :span="4">微信</el-col>
            <el-col :span="4"></el-col>
          </el-row>
          <div 
            v-for="(sale, index) in form.salesInfo" 
            :key="index" 
            class="sales-item"
          >
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item 
                  :prop="'salesInfo.' + index + '.name'"
                  :rules="{ required: true, message: $t('buildingManage.validate.saleNameRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="sale.name" 
                    :placeholder="$t('buildingManage.edit.saleNamePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <upload-image-url 
                    :ref="'saleHeadImage_' + index"
                    :limit="1"
                    @notifyUploadCoverImage="(images) => handleSaleHeadImageChange(index, images)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'salesInfo.' + index + '.job'"
                  :rules="{ required: true, message: $t('buildingManage.validate.saleJobRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="sale.job" 
                    :placeholder="$t('buildingManage.edit.saleJobPlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'salesInfo.' + index + '.tel'"
                  :rules="{ required: true, message: $t('buildingManage.validate.saleTelRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="sale.tel" 
                    :placeholder="$t('buildingManage.edit.saleTelPlaceholder')" 
                    :maxlength="20"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <upload-image-url 
                    :ref="'saleWxQrcode_' + index"
                    :limit="1"
                    @notifyUploadCoverImage="(images) => handleSaleWxQrcodeChange(index, images)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button 
                    type="danger" 
                    icon="el-icon-delete" 
                    circle 
                    @click="removeSale(index)"
                  ></el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          
          <el-button 
            type="primary" 
            icon="el-icon-plus" 
            @click="addSale"
          >
            {{ $t('buildingManage.edit.addSale') }}
          </el-button>
        </div>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { updateBuilding, getBuildingDetail } from '@/api/oa/buildingManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from "@/components/editor/RichTextEditor";
import SelectTiandituPos from '@/components/system/selectTiandituPos'

export default {
  name: 'EditBuilding',
  components: {
    UploadImageUrl,
    RichTextEditor,
    SelectTiandituPos
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        name: '',
        intro: '',
        tags: '',
        unitPrice: '',
        coverImg: '',
        headerImg: '',
        totalPrice: '',
        discountInfo: '',
        salesStatus: '',
        houseType: '',
        buildingType: '',
        propertyRight: '',
        buildingDesc: '',
        houseInfo: [], // 修改为数组
        salesInfo: [], // 改为数组
        features: '',
        lat: '',
        lng: '',
        telephone: '',
        address: '',
        communityId: '',
        showPrice: '0',
      },
      rules: {
        name: [
          { required: true, message: this.$t('buildingManage.validate.nameRequired'), trigger: 'blur' },
          { max: 100, message: this.$t('buildingManage.validate.nameMaxLength'), trigger: 'blur' }
        ],
        intro: [
          { max: 100, message: this.$t('buildingManage.validate.introMaxLength'), trigger: 'blur' }
        ],
        tags: [
          { max: 100, message: this.$t('buildingManage.validate.tagsMaxLength'), trigger: 'blur' }
        ],
        unitPrice: [
          { max: 50, message: this.$t('buildingManage.validate.unitPriceMaxLength'), trigger: 'blur' }
        ],
        coverImg: [
          { max: 255, message: this.$t('buildingManage.validate.coverImgMaxLength'), trigger: 'blur' }
        ],
        headerImg: [
          { max: 255, message: this.$t('buildingManage.validate.headerImgMaxLength'), trigger: 'blur' }
        ],
        totalPrice: [
          { max: 255, message: this.$t('buildingManage.validate.totalPriceMaxLength'), trigger: 'blur' }
        ],
        discountInfo: [
          { max: 255, message: this.$t('buildingManage.validate.discountInfoMaxLength'), trigger: 'blur' }
        ],
        salesStatus: [
          { required: false, message: this.$t('buildingManage.validate.salesStatusRequired'), trigger: 'change' },
          { max: 50, message: this.$t('buildingManage.validate.salesStatusMaxLength'), trigger: 'blur' }
        ],
        houseType: [
          { max: 100, message: this.$t('buildingManage.validate.houseTypeMaxLength'), trigger: 'blur' }
        ],
        buildingType: [
          { max: 255, message: this.$t('buildingManage.validate.buildingTypeMaxLength'), trigger: 'blur' }
        ],
        propertyRight: [
          { max: 255, message: this.$t('buildingManage.validate.propertyRightMaxLength'), trigger: 'blur' }
        ],
        address: [
          { max: 255, message: this.$t('buildingManage.validate.addressMaxLength'), trigger: 'blur' }
        ],
        lat: [
          { max: 10, message: this.$t('buildingManage.validate.latMaxLength'), trigger: 'blur' }
        ],
        lng: [
          { max: 10, message: this.$t('buildingManage.validate.lngMaxLength'), trigger: 'blur' }
        ],
        telephone: [
          { max: 20, message: this.$t('buildingManage.validate.telephoneMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(async () => {
        this.$refs.form && this.$refs.form.resetFields()
        await this.loadBuildingDetail(row.id)
        // this.$refs.selectMapPos && this.$refs.selectMapPos.initPosition({ lng: row.lng, lat: row.lat})
        setTimeout(() => {this.$refs.selectMapPos.initPosition({ lng: row.lng, lat: row.lat})},1000)
      })
    },
    async loadBuildingDetail(id) {
      try {
        const params = {
          id,
          page: 1,
          row: 50,
          communityId: getCommunityId()
        }
        const {buildings} = await getBuildingDetail(params)
        // 解析销售信息
        let salesInfo = [];
        if (buildings[0].salesInfo) {
          try {
            salesInfo = JSON.parse(buildings[0].salesInfo);
          } catch (e) {
            console.warn('解析销售信息失败:', e);
          }
        }
        
        // 解析房型信息
        let houseInfo = [];
        if (buildings[0].houseInfo) {
          try {
            houseInfo = JSON.parse(buildings[0].houseInfo);
          } catch (e) {
            console.warn('解析房型信息失败:', e);
          }
        }
        
        this.form = { 
          ...buildings[0],
          showPrice: buildings[0].showPrice !== undefined ? buildings[0].showPrice : '0',
          salesInfo: Array.isArray(salesInfo) ? salesInfo : [],
          houseInfo: Array.isArray(houseInfo) ? houseInfo : []
        }

        this.$refs.coverImage && this.$refs.coverImage.setImages([buildings[0].coverImg])
        this.$refs.headerImage && this.$refs.headerImage.setImages([buildings[0].headerImg])
        
        if (this.$refs.buildingDescEditor) {
          this.$refs.buildingDescEditor.setContent(buildings[0].buildingDesc || '')
        }
        // 移除对 houseInfoEditor 的引用，因为我们不再使用它
        
        // 设置房型图片
        if (Array.isArray(houseInfo)) {
          this.$nextTick(() => {
            houseInfo.forEach((house, index) => {
              if (house.img) {
                const refKey = 'houseImage_' + index;
                if (this.$refs[refKey]) {
                  this.$refs[refKey][0].setImages([house.img]);
                }
              }
            });
          });
        }
        
        // 设置销售图片
        if (Array.isArray(salesInfo)) {
          this.$nextTick(() => {
            salesInfo.forEach((sale, index) => {
              if (sale.head) {
                const refKey = 'saleHeadImage_' + index;
                if (this.$refs[refKey]) {
                  this.$refs[refKey][0].setImages([sale.head]);
                }
              }
              if (sale.wxQrcode) {
                const qrcodeRefKey = 'saleWxQrcode_' + index;
                if (this.$refs[qrcodeRefKey]) {
                  this.$refs[qrcodeRefKey][0].setImages([sale.wxQrcode]);
                }
              }
            });
          });
        }
        
        if (this.$refs.featuresEditor) {
          this.$refs.featuresEditor.setContent(buildings[0].features || '')
        }
      } catch (error) {
        console.error('获取楼盘详情失败:', error)
      }
    },
    handleCoverImageChange(images) {
      this.form.coverImg = images.length > 0 ? images[0] : ''
    },
    handleHeaderImageChange(images) {
      this.form.headerImg = images.length > 0 ? images[0] : ''
    },
    handleSaleHeadImageChange(index, images) {
      this.$set(this.form.salesInfo[index], 'head', images.length > 0 ? images[0] : '')
    },
    handleSaleWxQrcodeChange(index, images) {
      this.$set(this.form.salesInfo[index], 'wxQrcode', images.length > 0 ? images[0] : '')
    },
    // 房型图片处理方法
    handleHouseImageChange(index, images) {
      this.$set(this.form.houseInfo[index], 'img', images.length > 0 ? images[0] : '')
    },
    // 添加销售人员
    addSale() {
      this.form.salesInfo.push({
        name: '',
        head: '',
        job: '',
        tel: '',
        wxQrcode: ''
      })
    },
    // 删除销售人员
    removeSale(index) {
      this.form.salesInfo.splice(index, 1)
      
      // 清理对应的图片引用
      this.$nextTick(() => {
        const headRefKey = 'saleHeadImage_' + index
        if (this.$refs[headRefKey]) {
          this.$refs[headRefKey][0].clearImages()
        }
        const qrcodeRefKey = 'saleWxQrcode_' + index
        if (this.$refs[qrcodeRefKey]) {
          this.$refs[qrcodeRefKey][0].clearImages()
        }
      })
    },
    // 添加房型
    addHouse() {
      this.form.houseInfo.push({
        category: '',
        name: '',
        img: '',
        size: '',
        state: '',
        price: ''
      })
    },
    // 删除房型
    removeHouse(index) {
      this.form.houseInfo.splice(index, 1)
      
      // 清理对应的图片引用
      this.$nextTick(() => {
        const refKey = 'houseImage_' + index
        if (this.$refs[refKey]) {
          this.$refs[refKey][0].clearImages()
        }
      })
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.form.communityId = getCommunityId()
            // tags 中文逗号替换成英文逗号
            this.form.tags = this.form.tags.replace(/，/g, ',')
            // 确保 salesInfo 是一个 JSON 字符串
            // 确保 houseInfo 是一个 JSON 字符串
            const formData = {
              ...this.form,
              salesInfo: JSON.stringify(this.form.salesInfo),
              houseInfo: JSON.stringify(this.form.houseInfo)
            }
            await updateBuilding(formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('更新楼盘失败:', error)
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handlePositionChange(position) {
      this.form.lng = position.lng ? position.lng.toString() : ''
      this.form.lat = position.lat ? position.lat.toString() : ''
    }
  }
}
</script>

<style scoped>
.house-info-container,
.sales-info-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
}

.house-item,
.sales-item {
  padding: 10px 0;
  border-bottom: 1px dashed #ebeef5;
}

.house-item:last-child,
.sales-item:last-child {
  border-bottom: none;
}

.el-button.el-button--danger.is-circle {
  padding: 8px;
  min-width: auto;
}
</style>
